/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_stats_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Fantasy Stats tab focuses on what matters for your team: total points, average points per race, price, and PPM (Points Per Million). PPM measures how many fantasy points a driver earns relative to their cost — it’s the key stat for finding underpriced picks.`)
};

const es_f1_stats_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La pestaña de Fantasy Stats se centra en lo que importa para tu equipo: puntos totales, puntos promedio por carrera, precio y PPM (Puntos Por Millón). El PPM mide cuántos puntos de fantasy obtiene un piloto en relación con su coste — es la estadística clave para encontrar picks infravalorados.`)
};

const de_f1_stats_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Fantasy-Stats-Tab konzentriert sich auf das, was für dein Team zählt: Gesamtpunkte, Durchschnittspunkte pro Rennen, Preis und PPM (Punkte pro Million). PPM misst, wie viele Fantasy-Punkte ein Fahrer im Verhältnis zu seinen Kosten erzielt — die Schlüsselstatistik, um unterbewertete Picks zu finden.`)
};

const nl_f1_stats_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het tabblad Fantasy Stats richt zich op wat telt voor je team: totale punten, gemiddelde punten per race, prijs en PPM (Punten Per Miljoen). PPM meet hoeveel fantasy-punten een coureur verdient ten opzichte van zijn kosten — dé sleutelstat om ondergewaardeerde picks te vinden.`)
};

const fr_f1_stats_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’onglet Fantasy Stats se concentre sur ce qui compte pour votre équipe : points totaux, points moyens par course, prix et PPM (Points Par Million). Le PPM mesure combien de points fantasy un pilote gagne par rapport à son coût — c’est la statistique clé pour trouver les picks sous-évalués.`)
};

const it_f1_stats_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La scheda Fantasy Stats si concentra su ciò che conta per la tua squadra: punti totali, media punti per gara, prezzo e PPM (Punti Per Milione). Il PPM misura quanti punti fantasy un pilota guadagna rispetto al suo costo — è la statistica chiave per trovare le scelte sottovalutate.`)
};

const pt_br2_f1_stats_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A aba Fantasy Stats foca no que importa para seu time: pontos totais, média de pontos por corrida, preço e PPM (Pontos Por Milhão). O PPM mede quantos pontos fantasy um piloto ganha em relação ao seu custo — é a estatística chave para encontrar escolhas subvalorizadas.`)
};

const pt_f1_stats_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O separador Fantasy Stats foca-se no que importa para a sua equipa: pontos totais, média de pontos por corrida, preço e PPM (Pontos Por Milhão). O PPM mede quantos pontos fantasy um piloto ganha em relação ao seu custo — é a estatística chave para encontrar escolhas subvalorizadas.`)
};

const ja_f1_stats_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy Statsタブはチームにとって重要なことに焦点を当てます：合計ポイント、レースあたりの平均ポイント、価格、PPM（ポイント・パー・ミリオン）。PPMはドライバーがコストに対してどれだけのファンタジーポイントを獲得するかを測定 — 割安なピックを見つけるための重要な統計です。`)
};

const zh_f1_stats_how_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`梦幻统计标签聚焦于对你的车队最重要的内容：总积分、每场比赛平均积分、价格和PPM（每百万积分）。PPM衡量车手相对于其成本获得的梦幻积分 — 是发现被低估选择的关键数据。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_stats_how_p2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_stats_how_p2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_stats_how_p2", locale)
	if (locale === "en") return en_f1_stats_how_p2(inputs)
	if (locale === "es") return es_f1_stats_how_p2(inputs)
	if (locale === "de") return de_f1_stats_how_p2(inputs)
	if (locale === "nl") return nl_f1_stats_how_p2(inputs)
	if (locale === "fr") return fr_f1_stats_how_p2(inputs)
	if (locale === "it") return it_f1_stats_how_p2(inputs)
	if (locale === "pt-BR") return pt_br2_f1_stats_how_p2(inputs)
	if (locale === "pt") return pt_f1_stats_how_p2(inputs)
	if (locale === "ja") return ja_f1_stats_how_p2(inputs)
	return zh_f1_stats_how_p2(inputs)
};